<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="gare-container">
    <div v-show="step == 1">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
          <div class="right">
            <p>
              Ici, c’est le standard téléphonique du jam. On est 40 personnes à se relayer pour passer les
              conversations, il faut être sacrément concentré·es !
            </p>
            <div class="arrowright"></div>
          </div>
          <div class="right">
            <p>
              De ce fait, je n’ai pas beaucoup de temps : montrez-moi votre liste ?
              <br />Ouh là ! On a rien de tout ça nous ! Par contre, je peux vous montrer comment notre standard
              fonctionne, si ça vous dit d’essayer vous-mêmes.
            </p>
            <div class="arrowright"></div>
          </div>

          <div class="object" v-on:click="step += 1">Relever le défi</div>
        </div>
        <div class="col-md-1"></div>
        <div class="col-md-4">
          <img class="standardiste" src="https://cdn.exploreve.fr/content/cluedo/standardiste.svg" height="400px" />
        </div>
      </div>
    </div>
    <div v-show="step == 2">
      <div class="row">
        <div class="col-md-8">
          <Standard v-on:finish="step += 1" />
        </div>
        <div class="col-md-4">
          <div class="left" style="max-width: 250px; position: relative; left: 100px;">
            <div class="arrowleft"></div>
            <p>
              Essaie de relier les carrés aux ronds de la même couleur. Si tu relies tous les câbles, tu entendras un
              extrait téléphonique. Écoute-les bien jusqu'au bout !
            </p>
          </div>
          <img class="standardiste" src="https://cdn.exploreve.fr/content/cluedo/standardiste.svg" height="400px" />
        </div>
      </div>
    </div>
    <div v-show="step == 3">
      <div class="row">
        <div class="col-md-4">
          <div class="left" style="max-width: 400px; position: relative; left: 100px;">
            <div class="arrowleft"></div>
            <p>
              Bravo tu as réussi à connecter tous ces câbles aussi rapidement que nos standardistes, grâce à toi nous
              avons pu établir le contact avec toutes ces personnes ! Quelle vitesse!
            </p>
          </div>
          <img class="standardiste" src="https://cdn.exploreve.fr/content/cluedo/standardiste.svg" height="400px" />
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.right {
  max-width: 400px !important;
}

.standardiste {
  margin-right: 50px;
  position: absolute;
  top: 50px; /* poussé de la moitié de hauteur du référent */
}
</style>
<script>
import Standard from "@/components/cluedo/Colourshift.vue";
export default {
  data: function () {
    return {
      step: 1
    };
  },
  mounted() {},
  props: {},
  methods: {},
  components: { Standard }
};
</script>
